module.exports = __webpack_public_path__ + "img/1024.2babf9da.png";